(() => {
  const getSelectedControl = (group) =>
    group.querySelector('input[type="radio"]:checked') || group.querySelector('select option:checked');

  const getGroups = (picker) =>
    Array.from(picker.querySelectorAll('fieldset, .product-form__input--dropdown')).filter((group) =>
      getSelectedControl(group)
    );

  const selectVariantOptions = (picker, variant) => {
    if (!variant?.options) return;

    getGroups(picker).forEach((group, index) => {
      const desiredValue = variant.options[index];
      const radio = Array.from(group.querySelectorAll('input[type="radio"]')).find(
        (input) => input.value === desiredValue
      );
      const select = group.querySelector('select');

      if (radio) radio.checked = true;
      if (select) {
        const option = Array.from(select.options).find((item) => item.value === desiredValue);
        if (option) {
          Array.from(select.options).forEach((item) => item.removeAttribute('selected'));
          option.selected = true;
          option.setAttribute('selected', 'selected');
        }
      }
    });
  };

  const ensureCompatibleCombination = (event) => {
    const target = event.target;
    if (!(target instanceof HTMLInputElement) || target.type !== 'radio') return;

    const picker = target.closest(
      'variant-selects[data-product-family="canvas"], variant-selects[data-product-family="glass"], variant-selects[data-product-family="wallpaper"]'
    );
    if (!picker || !target.closest('[data-wta-option-kind="visual"], [data-wta-option-kind="material"]')) return;

    const variantsScript = picker.querySelector('[data-wta-variants]');
    if (!variantsScript) return;

    let variants;
    try {
      variants = JSON.parse(variantsScript.textContent);
    } catch (error) {
      console.error('WallTheArt variant data could not be parsed.', error);
      return;
    }

    const groups = getGroups(picker);
    const selectedValues = groups.map((group) => getSelectedControl(group)?.value);
    const changedPosition = Number(target.dataset.optionPosition || 1) - 1;
    selectedValues[changedPosition] = target.value;

    const exactVariant = variants.find(
      (variant) => variant.available && variant.options.every((value, index) => value === selectedValues[index])
    );

    if (exactVariant) return;

    const compatibleVariant = variants.find(
      (variant) => variant.available && variant.options[changedPosition] === target.value
    );

    if (compatibleVariant) selectVariantOptions(picker, compatibleVariant);
  };

  document.addEventListener('change', ensureCompatibleCombination, true);
})();
